import { List } from '@mui/material';

import styled from 'styled-components';

export const AccordionDetailsList = styled(List)`
  &.MuiList-padding {
    padding-left: ${({ theme }) => theme.spacing(7)};
  }
`;
